<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0004 24C15.1019 19.3206 19.0966 15.3141 24.0004 12C19.0966 8.6859 15.1045 4.67937 12.0004 0C8.89886 4.67937 4.9041 8.6859 0.000366211 12C4.9041 15.3141 8.89624 19.3206 12.0004 24Z" fill="currentColor"/>
</svg>
